// extracted by mini-css-extract-plugin
var _1 = "src-components-SignupForm-_TextModalDialog__dialogCloseButton--YusRfkcrdtiv6voZze57";
var _2 = "src-components-SignupForm-_TextModalDialog__dialogCloseButtonWrapper--HtuLhsYp3p08wrB2Cu06";
var _3 = "src-components-SignupForm-_TextModalDialog__dialogText--ERbU6BwTpU9BJkw9oaH8";
var _4 = "src-components-SignupForm-_TextModalDialog__textModalDialog--Z0HBO_x4MiFee5tSleOL";
export { _1 as "dialogCloseButton", _2 as "dialogCloseButtonWrapper", _3 as "dialogText", _4 as "textModalDialog" }
